(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["conutry-selector"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  function watchElement(selector, callback, disconnectOnFound = false) {
    const observer = new MutationObserver((mutations, obs) => {
      const el = document.querySelector(selector);
      if (el && !el.hasAttribute('data-observed')) {
        el.setAttribute('data-observed', 'true');
        callback(el);
        if (disconnectOnFound) obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return observer;
  }

  function safeAppendOnce(parent, childHTML) {
    if (!parent || !childHTML) return;
    const existing = parent.querySelector('.country-selector-wrapper');
    if (existing) existing.remove();

    const wrapper = document.createElement('div');
    wrapper.className = 'country-selector-wrapper';
    wrapper.appendChild(childHTML);
    parent.appendChild(wrapper);
  }

  let templateReady = false;
  let dropdownCloneTpl = null;

  const templateObs = watchElement('.e_country_selector', (templateEl) => {
    if (templateReady) return;
    templateReady = true;
    templateObs.disconnect();

    const currentSelectEl = templateEl.content.querySelector('.current_select');
    const dropdownNavEl = templateEl.content.querySelector('.dropdown__nav');
    if (dropdownNavEl) dropdownCloneTpl = dropdownNavEl;

    if (currentSelectEl) {
      watchElement('.e_header_country_label', (btn) => {
        if (!btn.querySelector('.current_select')) {
          btn.prepend(currentSelectEl.cloneNode(true));
        }
      });
      watchElement('.announcement-country-button', (btn) => {
        if (!btn.querySelector('.current_select')) {
          btn.prepend(currentSelectEl.cloneNode(true));
        }
      });
    }

    if (dropdownCloneTpl) {
      watchElement('#header_drawer_localization_country_form', (form) => {
        safeAppendOnce(form, dropdownCloneTpl.cloneNode(true));
      });

      watchElement('#announcement_localization_country_form', (form) => {
        safeAppendOnce(form, dropdownCloneTpl.cloneNode(true));
      });
    }
  });

  document.addEventListener('click', (e) => {
    const form = e.target.closest('#announcement_localization_country_form');
    if (!form) return;
    const link = e.target.closest('a[href]');
    if (link) {
      e.preventDefault();
      window.location.href = link.href;
    }
  }, true);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-section-two"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-reveal-media')) {
    customElements.define('scroll-reveal-media', class extends HTMLElement {
      constructor() {
        super();
        this.wrapper = this.querySelector('.animation-wrapper');
        this.stickySection = this.querySelector('.sticky-section');
        this.textEl = this.querySelector('.text-content');
        this.placeholder = this.querySelector('.img-placeholder');
        this.media = this.querySelector('.inline-media');
        
        this.allChars = [];
        this.totalChars = 0;
        this.startRect = null;
        this.ticking = false;
        this.isVideoPlaying = false;
        
        this.onScroll = this.onScroll.bind(this);
        this.updateAnimation = this.updateAnimation.bind(this);
        this.updateRect = this.updateRect.bind(this);
      }

      connectedCallback() {
        if (!this.wrapper || !this.textEl || !this.placeholder || !this.media) return;
        this.initTextSplit();
        if (this.media.tagName === 'VIDEO') {
          this.media.pause();
        }
        window.addEventListener('load', this.updateRect);
        window.addEventListener('resize', this.updateRect);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        document.addEventListener('shopify:section:load', this.updateRect);
        setTimeout(this.updateRect, 100);
      }

      disconnectedCallback() {
        window.removeEventListener('load', this.updateRect);
        window.removeEventListener('resize', this.updateRect);
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('shopify:section:load', this.updateRect);
      }

      initTextSplit() {
        const nodes = Array.from(this.textEl.childNodes);
        this.textEl.innerHTML = '';
        
        nodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.classList.contains('img-placeholder')) {
              this.textEl.appendChild(node);
            } else if (node.nodeName.toLowerCase() === 'br') {
              this.textEl.appendChild(document.createElement('br'));
            }
          } 
          
          else if (node.nodeType === 3) {
            const str = node.textContent;
            for (let i = 0; i < str.length; i++) {
              const span = document.createElement('span');
              span.className = 'char';
              span.textContent = str[i];
              this.textEl.appendChild(span);
              this.allChars.push(span);
            }
          }
        });
        
        this.totalChars = this.allChars.length;
      }

      updateRect() {
        const pRect = this.placeholder.getBoundingClientRect();
        const cRect = this.stickySection.getBoundingClientRect();

        this.startRect = {
          top: pRect.top - cRect.top,
          left: pRect.left - cRect.left,
          width: pRect.width,
          height: pRect.height
        };

        this.media.style.opacity = 1;
        this.updateAnimation();
      }

      onScroll() {
        if (!this.ticking) {
          window.requestAnimationFrame(() => {
            this.updateAnimation();
            this.ticking = false;
          });
          this.ticking = true;
        }
      }

      updateAnimation() {
        if (!this.startRect) return;

        const wrapperRect = this.wrapper.getBoundingClientRect();
        const scrollDistance = -wrapperRect.top;
        const maxScroll = wrapperRect.height - window.innerHeight;

        let progress = 0;
        if (maxScroll > 0) {
          progress = Math.min(1, Math.max(0, scrollDistance / maxScroll));
        }

        const p1 = Math.min(1, progress / 0.4);
        const p2 = Math.min(1, Math.max(0, (progress - 0.4) / 0.2));
        const p3 = Math.min(1, Math.max(0, (progress - 0.6) / 0.2));

        const exactFill = this.totalChars * p1; 
        const fadeSpread = 12; 

        this.allChars.forEach((c, i) => {
          const globalFadeOut = 1 - p2;

          if (i <= exactFill) {
            c.style.opacity = 1 * globalFadeOut;
          } else {
            const distance = i - exactFill;
            if (distance < fadeSpread) {
              const ratio = 1 - (distance / fadeSpread); 
              const currentOpacity = 0.15 + (0.85 * ratio); 
              c.style.opacity = currentOpacity * globalFadeOut;
            } else {
              c.style.opacity = 0.15 * globalFadeOut;
            }
          }
        });

        const currentWidth = this.startRect.width + (window.innerWidth - this.startRect.width) * p3;
        const currentHeight = this.startRect.height + (window.innerHeight - this.startRect.height) * p3;
        const currentLeft = this.startRect.left * (1 - p3);
        const currentTop = this.startRect.top * (1 - p3);
        const currentRadius = 10 * (1 - p3);

        this.media.style.transform = `translate3d(${currentLeft}px, ${currentTop}px, 0)`;
        this.media.style.width = `${currentWidth}px`;
        this.media.style.height = `${currentHeight}px`;
        this.media.style.borderRadius = `${currentRadius}px`;

        // 视频全屏时播放，否则暂停
        if (this.media.tagName === 'VIDEO') {
          if (p3 >= 0.99 && !this.isVideoPlaying) {
            this.media.play().catch(err => {});
            this.isVideoPlaying = true;
          } else if (p3 < 0.99 && this.isVideoPlaying) {
            this.media.pause();
            this.isVideoPlaying = false;
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
